import type { Stats } from '@repo/shared';
import type { ConnectionStatus } from '../lib/useEventStream';
import { localeTimestamp, since } from '../lib/format';
import styles from './StatPanels.module.css';

const STATUS_LABEL: Record<ConnectionStatus, string> = {
  connecting: 'connecting',
  live: 'live',
  reconnecting: 'reconnecting',
  offline: 'offline',
};

function Stat({
  label,
  value,
  hint,
  title,
}: {
  label: string;
  value: string;
  hint?: string;
  title?: string;
}) {
  return (
    <div className={styles.stat} title={title}>
      <div className={styles.value}>{value}</div>
      <div className={styles.label}>{label}</div>
      {hint && <div className={styles.hint}>{hint}</div>}
    </div>
  );
}

/** Top strip: headline counters + connection state. */
export function StatPanels({ stats, status }: { stats: Stats; status: ConnectionStatus }) {
  return (
    <div className={styles.panels}>
      <Stat label="total attacks" value={stats.totalAttacks.toLocaleString()} />
      <Stat
        label="requests seen"
        value={stats.totalRequests.toLocaleString()}
        hint="attacks + page/asset hits"
      />
      <Stat label="attacks / min" value={String(stats.attacksPerMin)} />
      <Stat
        label="watching since"
        value={since(stats.firstSeen)}
        hint="ring-buffer uptime"
        title={stats.firstSeen ? `First probe: ${localeTimestamp(stats.firstSeen)}` : undefined}
      />
      <div className={`${styles.stat} ${styles.status}`}>
        <div className={styles.statusRow}>
          <span className={`${styles.dot} ${styles[status]}`} />
          <span className={styles.value}>{STATUS_LABEL[status]}</span>
        </div>
        <div className={styles.label}>connection</div>
      </div>
    </div>
  );
}
